import { render, staticRenderFns } from "./SwipeDeletable.vue?vue&type=template&id=2a87c7d6&scoped=true&"
import script from "./SwipeDeletable.vue?vue&type=script&lang=ts&"
export * from "./SwipeDeletable.vue?vue&type=script&lang=ts&"
import style0 from "./SwipeDeletable.vue?vue&type=style&index=0&id=2a87c7d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a87c7d6",
  null
  
)

export default component.exports